import { useAppDispatch } from "@/shared/lib/redux"
import { SidebarLogo } from "./sidebar-logo"
import { SidebarMenu } from "./sidebar-menu"
import { setSidebarType } from "../model"
import { useLocation } from "react-router-dom"
import { useEffect } from "react"

export const Sidebar = () => {
    const location = useLocation();
    const dispatch = useAppDispatch()
    const query = new URLSearchParams(location.search)
    useEffect(() => {
        const s_type = query.get('s_type')
        if (s_type) {
            dispatch(setSidebarType(s_type))
        }
    }, [location])

    return (
        <div className="w-[290px] shrink-0 flex flex-col bg-white">
            <div className="mx-auto w-fit py-10">
                <SidebarLogo />
            </div>
            <div className="w-full bg-[#B9C9C6] h-[1px] block" />
            <div className="overflow-auto no-scrollbar">
                <SidebarMenu />
            </div>
        </div>
    )
}
